import SwitchLanguage from './SwitchLanguage'
export default SwitchLanguage
